<template>
  <b-container fluid>
    <b-row class="mb-5">
      <back-button class="back-buton"/>
      <slot name="bannerImage" />
    </b-row>
    <b-row class="mb-3">
      <b-col xl="6">
        <b-row class="mb-3" align-h="center">
          <b-col sm="12" xl="8">
            <p class="h1">{{pageHeaderText}}</p>
            <b-button
              class="mb-3 mr-4"
              :href="capabilityUrl"
              variant="outline-secondary"
              size="xl"
              >{{ loginText }}
            </b-button>
            <p v-if="documentationUrl">
              <b-link
                class="linkBoarder p-1 font-weight-bold"
                target="_blank"
                :href="documentationUrl"
                >View Technical Documentation<b-icon-arrow-right
              /></b-link>
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col xl="6">
        <b-row>
          <b-col cols="12">
            <slot name="whatIsSection" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="backgroundColor pt-5 pb-5 mb-3">
      <b-col xl="6">
        <b-row class="mb-3" align-h="center"
          v-if="capabilityVideoUrl">
          <b-col sm="12" xl="8">
            <slot name="explainedSection" />
          </b-col>
        </b-row>
        <b-row class="pb-xl-5" align-h="center"
          v-if="capabilityVideoUrl">
          <b-col sm="12" xl="8">
            <b-embed
              align-self="center"
              type="iframe"
              aspect="16by9"
              :src="capabilityVideoUrl"
              allowfullscreen
            ></b-embed>
          </b-col>
        </b-row>
        <b-row
           :class="possibleUsesCss" align-h="center">
           <b-col sm="12" xl="8">
            <slot name="possibleUses" />
          </b-col>
        </b-row>
      </b-col>
      <b-col xl="6">
        <slot name="imageSection1" />
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="6">
        <b-row align-h="center">
          <b-col class="mb-3" cols="8">
            <slot name="imageSection2" />
          </b-col>
        </b-row>
      </b-col>
      <b-col xl="6">
        <b-row>
          <b-col class="mb-3" sm="12">
            <slot name="makesADifferenceSection" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <contact-expert />
    <b-row align-h="center" class="homeBanner">
      <b-col xl="6" class="text-xl-right text-sm-center">
        <h1>Trust us for</h1>
      </b-col>
      <b-col xl="6">
        <ul>
          <li>SABS and ISO compliant Address data.</li>
          <li>Accurate and verified address results returned.</li>
          <li>
            Components available via API to integrate into your own solutions.
          </li>
          <li>Over 50 Million searchable address combinations.</li>
        </ul>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BButton,
  BContainer,
  BCol,
  BEmbed,
  BLink,
  BRow,
  BIconArrowRight,
} from 'bootstrap-vue';

import oidcAuth from '@/mixins/oidcAuth';
import ContactExpert from '@/components/ContactExpert.vue';
import BackButton from '@/components/BackButton.vue';

export default {
  components: {
    BackButton,
    BButton,
    BContainer,
    BCol,
    BEmbed,
    BLink,
    BRow,
    BIconArrowRight,
    ContactExpert,
  },
  computed: {
    loginText() {
      return this.disableLoginText || this.oidcIsAuthenticated ? 'Try it' : 'Login & Try it';
    },
    possibleUsesCss() {
      return this.capabilityVideoUrl ? 'mt-5 mb-3' : 'mb-3';
    },
  },
  props: {
    pageHeaderText: {
      required: true,
      type: String,
    },
    capabilityUrl: {
      required: true,
      type: String,
    },
    documentationUrl: {
      default: null,
      required: false,
      type: String,
    },
    capabilityVideoUrl: {
      required: false,
      type: String,
    },
    disableLoginText: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [oidcAuth],
};
</script>

<style scoped>
.backgroundColor {
  background-color: #f8f9fa;
}
.homeBanner {
  background-image: url('../assets/images/Image_1920x300.webp');
  color: white;
  padding: 3rem!important;
}

@media screen and (max-width: 600px) {
  .homeBanner {
    padding: 1rem!important;
  }
}

.back-buton {
  position: absolute;
  margin: 10px 10px auto;
  z-index: 500;
  cursor: pointer;
}

</style>
